import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ConfigurationState } from './types';
import { RootState } from '@/vuex/types';
import esens from '@/plugins/vuetify/themes/esens';
import zoukwroclove from '@/plugins/vuetify/themes/zoukwroclove';

const environments = {
    local: { name: 'local', apiUrl: 'http://localhost:54328' },
    localcore: { name: 'localcore', apiUrl: 'https://localhost:44332' },
    esens: { name: 'esens', apiUrl: 'https://apischedule.esens.com.pl' },
    zoukwroclove: { name: 'zoukwroclove', apiUrl: 'https://api.zoukwroclove.pl' },
    dev: { name: 'dev', apiUrl: 'http://devapi.zoukwroclove.pl' },
    uat: { name: 'uat', apiUrl: 'http://uatapi.zoukwroclove.pl' },
};

const appThemes = {
    zoukwroclove: zoukwroclove,
    esens: esens,
};

export const state: ConfigurationState = {
    appBarSettings: { visible: false },
    appWindowSettings: { mode: 'ScheduleBoard' },
    environments: environments,
    appThemes: appThemes,
    environment: environments.zoukwroclove,
    appTheme: appThemes.zoukwroclove,
};

const namespaced = true;

export const configuration: Module<ConfigurationState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
